export default __webpack_public_path__ + "static/media/hyipland.5f574d15.jpg";